module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group question"
  }, [_c('label', {
    staticClass: "question-label"
  }, [_vm._v(_vm._s(_vm.currentQuestion.label))]), _vm._v(" "), (_vm.currentQuestion.image) ? _c('div', {
    staticClass: "question-image"
  }, [_c('img', {
    attrs: {
      "src": _vm.currentCdn + '/img/' + _vm.currentQuestion.image
    }
  })]) : _vm._e(), _vm._v(" "), _vm._l((_vm.currentQuestion.reponses), function(reponse) {
    return _c('response', {
      key: reponse.id,
      attrs: {
        "question": _vm.currentQuestion,
        "response": reponse
      },
      on: {
        "input": function($event) {
          _vm.updateValue($event)
        }
      }
    })
  }), _vm._v(" "), (_vm.currentQuestion.info) ? _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.currentQuestion.info)
    }
  }) : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e2362c24"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Question.vue
// module id = 19
// module chunks = 0